import analyticCounters, { OptionsList, TExtendCounterOptions, } from '@media-platform/analytic-counters';
import counters from './counters';
export const AnalyticCounters = analyticCounters({ counters });
export const counterTrigger = (name: string, extendOptions?: TExtendCounterOptions) => {
    AnalyticCounters.counterTrigger({
        extendOptions,
        name,
    });
};
export const hitRbCounter = (counter: string) => {
    try {
        const cntrsCtrl = window.ru.mail.cpf.Instances.cntrsCtrl;
        const counterNo = cntrsCtrl.add('rbmail', {
            id: counter,
        });
        if (!isNaN(counterNo)) {
            cntrsCtrl.hit(counterNo);
        }
    }
    catch (e) {
        console.error('cntrsCtrl не доступен, проверьте наличие window.ru.mail.cpf.Instances.cntrsCtrl в момент вызова счетчика ' +
            counter);
    }
};
export const counterTriggerAll = (params?: OptionsList) => AnalyticCounters.triggerAll('.js-counters', params);
export const hitCounter = (id: number | string, prefix: string | undefined = 'd') => {
    const rand = Math.ceil(Math.random() * 1e9);
    new Image().src = `//rs.mail.ru/${prefix}${id}.gif?rnd=${rand}`;
};
